import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { Tag } from 'antd';
import "antd/dist/antd.min.css";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './SeacrhFilter.scss';

const OTHER_CATEGORIES = [
  { label: 'Toys', slug: 'toys' },
  { label: 'Fashion', slug: 'fashion' },
  { label: 'Gaming & Console', slug: 'gaming console' },
  { label: 'Headphones', slug: 'headphones' },
  { label: 'Accessories', slug: 'accessories' },
  { label: 'Musical Instrument', slug: 'musical instrument' },
  { label: 'Gift sets', slug: 'Gift sets' },
  { label: 'Mens Grooming', slug: 'Mens Grooming' },
  { label: 'Laptops', slug: 'laptops' },
  { label: 'Phones', slug: 'phones' },
];

const BRAND_PREVIEW_COUNT = 8;

function SeacrhFilter({ searchCountry, getProducts, isFetching }) {
  const { t } = useTranslation()
  const location = useLocation();
  const searchThisCountry = new URLSearchParams(location.search).get('country') || null
  const thisCountry = searchThisCountry ? `&country=${searchThisCountry}` : ''
  const [showAllBrands, setShowAllBrands] = useState(false);
  const uniqueBrands = [...new Set(getProducts?.map(p => p.brand))]?.filter(Boolean);
  const pathName = window.location.pathname?.split('/')
  const activeSlug = pathName?.[pathName.length - 1]?.toLowerCase();

  return (
    <div className="col-md-2 mob-w100" style={{ padding: '5px' }}>
      <div
        className="lx-filter"
        style={{ pointerEvents: isFetching ? 'none' : 'auto', opacity: isFetching ? 0.5 : 1 }}
      >

        <div className="lx-filter__section">
          <div className="lx-filter__eyebrow">{t('other_categories')}</div>
          <nav className="lx-filter__list">
            {OTHER_CATEGORIES.map((category) => (
              <Link
                key={category.slug}
                to={`/search/${encodeURIComponent(category.slug)}`}
                className={`lx-filter__link ${activeSlug === category.slug.toLowerCase() ? 'lx-filter__link--active' : ''}`}
              >
                {category.label}
              </Link>
            ))}
          </nav>
        </div>

        {uniqueBrands?.length > 1 &&
          <div className="lx-filter__section">
            <div className="lx-filter__eyebrow">{t('brands') || 'Brands'}</div>
            <div className="lx-filter__brands">
              {uniqueBrands?.slice(0, showAllBrands ? uniqueBrands.length : BRAND_PREVIEW_COUNT)?.map((item, i) => (
                <Link
                  key={item}
                  to={pathName?.includes('search') ? `/search/${encodeURIComponent(item)}` : `${window.location.pathname}?brand=${encodeURIComponent(item)}${thisCountry}`}
                >
                  <Tag className="lx-tag">{item}</Tag>
                </Link>
              ))}
            </div>

            {uniqueBrands?.length > BRAND_PREVIEW_COUNT &&
              <button
                type="button"
                className="lx-filter__toggle"
                onClick={() => setShowAllBrands((prev) => !prev)}
              >
                {showAllBrands ? t('show_less') : t('show_more')}
                {showAllBrands ? <KeyboardArrowUpIcon className="lx-filter__toggle-icon" /> : <KeyboardArrowDownIcon className="lx-filter__toggle-icon" />}
              </button>
            }
          </div>
        }

      </div>
    </div>
  );
}

export default SeacrhFilter;